// ブロック入札の「数量」列の表示形式 (AC-BSP-028)。
//
// ブロック入札は JEPX 制度上コマ毎に異なる入札量を指定できる (AC-BSP-030a) ため、
// 一覧の 1 行 (= 1 leg) に単一の数量が存在するとは限らない。 spec は
// 「全コマ同一量なら単一値、 コマ毎に異なる場合は代表値 + 詳細確認可能」までを規定し、
// 具体的な表記は EN/Des 判断範囲としている (spot-bidding.md AC-BSP-028 / :589)。
// 2026-08-25 の Des 推奨 (案 c: 全コマ同一なら単一値、 違う場合のみ「N〜M (可変)」) を採る
// — 大多数を占める「全コマ同一量」の見え方を変えずに済むため。
//
// 一覧テーブル ([[BlockBidTable]]) の表示形式。 CSV ダウンロードは取込にかけ直せるよう
// コマ別の実数量で出す ([[buildBlockBidCsvFiles]]) ので、 本 module は使わない。

/** 数量 1 件の表示桁 (= 0.1 MW 刻み)。 */
function formatMw(value: number): string {
  return value.toFixed(1)
}

/**
 * コマ別入札量の配列を「数量」列の表示文字列にする。
 *
 * - 全コマ同一量 (コマが 1 つだけの場合も含む) → `"100.0"`
 * - コマ毎に異なる → `"50.0〜100.0 (可変)"`
 * - コマ別値が空 (= 明細未取得) → `fallbackMwh` の単一値表示
 */
export function formatBlockVolumeLabel(
  slotVolumes: readonly number[],
  fallbackMwh: number,
): string {
  if (slotVolumes.length === 0) return formatMw(fallbackMwh)
  const min = Math.min(...slotVolumes)
  const max = Math.max(...slotVolumes)
  // 表示桁 (0.1 MW) まで丸めて同値なら単一値扱いにする (= 表示上区別できない差で
  // 「(可変)」を出さない)。
  if (formatMw(min) === formatMw(max)) return formatMw(min)
  return `${formatMw(min)}〜${formatMw(max)} (可変)`
}
